import { useAuthStore } from '@/core/store/AuthStore';
const auth = useAuthStore();

const authMapper = {
    userrole: auth.getUserRole,
    mapping: [{ name: 'Data Hub', auth: 0 }, 
              { name: 'LLM', auth: 1 }]
}

export default authMapper